import { Routes } from '@angular/router';
import { guestGuard } from './core/guards/guest.guard';
import { authGuard } from './core/guards/auth.guard';
import { dashboardGuard } from './core/guards/dashboard.guard';
import { ErrorPageComponent } from './features/error-page/error-page.component';

export const routes: Routes = [
  {
    path: 'account',
    loadChildren: () =>
      import('./features/account/account.route').then(m => m.ACCOUNT_ROUTES),
  },
  {
    path: 'partner/onboarding',
    loadChildren: () =>
      import('./features/partner-onboarding/onboarding.route').then(
        (m) => m.ONBOARDING_ROUTES
      ),
  },
    {
    path: 'account-warning',
    loadComponent: () => import('./features/account-warning/account-warning.component').then(m => m.AccountWarningComponent),
  },
  {
    path: 'account-suspended',
    loadComponent: () => import('./features/account-suspended/account-suspended.component').then(m => m.AccountSuspendedComponent),
  },
  {
    path: 'partner',
    loadChildren: () =>
      import('./features/dashboard-layout/dashboard-layout.route').then(
        (m) => m.DASHBOARD_ROUTES
      ),
  },
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'account/login', // 👈 required, but guard will override
  },
    { path: 'error', component: ErrorPageComponent },

  { path: '**', redirectTo: 'account/login' },
];
